import { UserSwitchOutlined } from "@ant-design/icons";
import { Button, message, Modal, Tag } from "antd";
import { toJalaali } from "jalaali-js";
import { forwardRef, useImperativeHandle, useState } from "react";
import api from "../../api/api";
import DataTable from "../DataTable/DataTable";

const OperatorSelector = ({ operators, data, setData }, ref) => {
  const [selectedOperator, setSelectedOperator] = useState();
  const [loading, setLoading] = useState(false);
  const [selectedRoadmaps, setSelectedRoadmaps] = useState([]);

  const [selectRoadmapsModal, setSelectRoadmapsModal] = useState(false);
  const [selectOperatorModal, setSelectedOperatorModal] = useState(false);

  const [showDeleteOperator, setShowDeleteOperator] = useState(false);

  const onSelectOperatorHandler = (record, selected) => {
    if (!selected) setSelectedOperator();
    setSelectedOperator(record);
  };

  useImperativeHandle(
    ref,
    () => ({
      open: (roadmapId) => {
        setSelectedRoadmaps([roadmapId]);
        setSelectRoadmapsModal(true);
        setSelectedOperator();
      },
    }),
    []
  );

  const addOperator = () => {
    if (!selectedOperator?.id) {
      message.warning("انتخاب اپراتور ضروری میباشد");
      return false;
    }

    setLoading(true);
    api
      .post("/roadmaps/setassignedto", {
        roadmapId: selectedRoadmaps,
        operatorId: selectedOperator?.id,
      })
      .then((res) => {
        setData((prev) =>
          prev.map((el) => ({
            ...el,
            ...(selectedRoadmaps.includes(el.id)
              ? {
                  assigned_to: `${selectedOperator?.firstname} ${selectedOperator?.lastname}`,
                }
              : {}),
          }))
        );
        setSelectedOperatorModal(false);
        message.success("تخصیص نقشه راه با موفقیت انجام شد.");
      })
      .catch((err) => {
        console.log({ err });
        message.error("تخصیص نقشه راه با مشکل مواجه شد.");
      })
      .finally(() => setLoading(false));
  };

  const operatorColumns = [
    {
      title: "نام",
      dataIndex: "firstname",
      searchable: true,
    },
    {
      title: "نام خانوادگی",
      dataIndex: "lastname",
      searchable: true,
    },
    {
      title: "نام کاربری",
      dataIndex: "username",
      searchable: true,
    },
  ];

  const roadmapsColumns = [
    {
      title: "نام و نام خانوادگی",
      dataIndex: "name",
      searchable: true,
      render: (ـ, record) => {
        return <span>{`${record?.name} ${record?.fname}`}</span>;
      },
    },
    {
      title: "محصول",
      filterMultiple: false,
      dataIndex: "product_private_title",
      filters: [
        { text: "نقشه راه روان‌شناسی", value: "roadmap-psychology" },
        { text: "نقشه راه لایف کوچ", value: "roadmap-3" },
      ],
      render: (text, record) => {
        return (
          <span title={record.product_code}>
            {record.product_private_title}
          </span>
        );
      },
    },
    {
      title: "اپراتور",
      dataIndex: "assigned_to",
      searchable: true,
      render: (assignedTo) => <Tag>{assignedTo || "ندارد"}</Tag>,
    },

    {
      title: "تاریخ درخواست",
      dataIndex: "submittedAt",
      render: (text, record) => {
        const date = new Date(record?.formAnsweredAt ?? text);
        const jalali = toJalaali(
          date.getFullYear(),
          date.getMonth() + 1,
          date.getDate()
        );
        return (
          <span dir="ltr">
            {jalali.jy}-{jalali.jm}-{jalali.jd} {date.toLocaleTimeString("eo", { hour12: false })}
          </span>
        );
      },
    },
    {
      title: "منتشر کننده",
      dataIndex: "publisher",
      searchable: true,
    },
  ];

  const onSelectRoadmaps = (record, selected) => {
    setSelectedRoadmaps((prev) => {
      if (selected) {
        return Array.from(new Set([...prev, record.id]));
      } else {
        return prev.filter((e) => e !== record.id);
      }
    });
  };

  const afterSelectRoadmaps = () => {
    if (selectedRoadmaps?.length === 0) {
      message.warning("حداقل یک نقشه راه انتخاب کنید");
      return;
    }
    setSelectRoadmapsModal(false);
    setSelectedOperatorModal(true);
  };

  const deleteOperatorHandler = () => {
    setLoading(true);
    api
      .post("/roadmaps/setassignedto", { roadmapId: selectedRoadmaps })
      .then((res) => {
        setData((prev) =>
          prev.map((el) => ({
            ...el,
            ...(selectedRoadmaps.includes(el.id)
              ? {
                  assigned_to: `-`,
                }
              : {}),
          }))
        );
        setSelectedOperatorModal(false);
        setSelectRoadmapsModal(false);

        message.success("حذف با موفقیت انجام شد");
      })
      .catch((err) => {
        console.log({ err });
        message.error("خطا در حذف اپراتور");
      })
      .finally(() => {
        setLoading(false);
        setShowDeleteOperator(false);
      });
  };

  return (
    <>
      {/* operators modal */}
      <Modal
        width="100%"
        destroyOnClose
        onCancel={() => {
          setSelectedOperatorModal(false);
        }}
        onOk={addOperator}
        okButtonProps={{ loading }}
        open={selectOperatorModal}
      >
        <DataTable
          tableKey="operator-selector-operators"
          header={{
            title: "اپراتورها",
            avatar: { icon: <UserSwitchOutlined />, size: "large" },
          }}
          dataSource={operators}
          setDataSource={() => {}}
          columns={operatorColumns}
          rowSelection={{
            hideSelectAll: true,
            onSelect: onSelectOperatorHandler,
            selectedRowKeys: selectedOperator?.id ? [selectedOperator?.id] : [],
            type: "radio",
          }}
        />
      </Modal>

      {/* roadmaps modal */}
      <Modal
        width="100%"
        destroyOnClose
        onCancel={() => {
          setSelectRoadmapsModal(false);
          setSelectedRoadmaps([]);
        }}
        onOk={afterSelectRoadmaps}
        okButtonProps={{ loading }}
        open={selectRoadmapsModal}
        footer={
          <>
            <Button
              style={{ color: "red" }}
              onClick={() => setShowDeleteOperator(true)}
            >
              حذف اپراتور
            </Button>
            <Button
              onClick={() => {
                setSelectRoadmapsModal(false);
                setSelectedRoadmaps([]);
              }}
            >
              لغو
            </Button>
            <Button onClick={afterSelectRoadmaps} type="primary">
              تایید
            </Button>
          </>
        }
      >
        <DataTable
          tableKey="operator-selector-roadmaps"
          header={{
            title: "نقشه راه ها",
            avatar: { icon: <UserSwitchOutlined />, size: "large" },
          }}
          dataSource={data}
          setDataSource={() => {}}
          columns={roadmapsColumns}
          rowSelection={{
            onSelect: onSelectRoadmaps,
            selectedRowKeys: selectedRoadmaps,
          }}
        />
      </Modal>

      {/* delete operator modal */}
      <Modal
        destroyOnClose
        onCancel={() => setShowDeleteOperator(false)}
        onOk={deleteOperatorHandler}
        title="حذف اپراتور نقشه ها"
        okButtonProps={{ loading }}
        open={showDeleteOperator}
      >
        <p>آیا از حذف اپراتور مطمئن هستید؟</p>
      </Modal>
    </>
  );
};

export default forwardRef(OperatorSelector);
